import { connect } from 'react-redux';
import { selectors as staffSelectors } from 'ducks/staff';
import CustomerPricingLookup from './CustomerPricingLookup';
import React from 'react';
import { ICustomerPricingLookupProps } from './CustomerPricingLookup.properties';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';
import CustomerPricingLookupStateProvider from './CustomerPricingLookup.context';

const mapStateToProps = (state) => ({
    DefaultWarehouse: staffSelectors.staff(state)?.defaultWarehouseEntity
});

const ConnectedComponent = connect(mapStateToProps, null)((props: Readonly<ICustomerPricingLookupProps>) => {
    return (<CustomerPricingLookupStateProvider>
        <CustomerPricingLookup
            {...props} />
    </CustomerPricingLookupStateProvider>
    );
});

export default React.forwardRef(
    (props: Readonly<ICustomerPricingLookupProps>, ref: React.Ref<IBasicLookupFieldHandle>) => {

        return <ConnectedComponent {...props} fieldRef={ref} />;
    });
